import { render, staticRenderFns } from "./SpirografiaEditComponent.vue?vue&type=template&id=18c0a4f8"
import script from "./SpirografiaEditComponent.vue?vue&type=script&lang=js"
export * from "./SpirografiaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports